<template>
    <div>       
        <br/>
        There are 10 levels of spells with 5 different types
         <v-row>            
            <v-col sm="2">
                 <h3>Links:</h3>
                <ul>
                    <li v-for="level in levels" :key="level"><a @click="scrollTo(level)" >Level {{level}}</a></li>                        
                </ul>
            </v-col>
            <v-col sm="2">
                 <h3>Types:</h3>
                <ul>
                    <li v-for="type in types" :key="type">{{type[0].toUpperCase() + type.substring(1)}}</li>                        
                </ul>
            </v-col>
            
            <v-col sm="3">
                <h3 class="mb-4">Level Filters:</h3>
                <v-row>
                    <v-col sm="4">
                        <v-row v-for="x in 5" :key="x" no-gutters>
                            <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="filters.levels[x-1]" :label="'Level ' + (x-1) "></v-checkbox>
                        </v-row>                               
                    </v-col>               

                    <v-col sm="4">             
                        <v-row v-for="x in 5" :key="x" no-gutters>
                            <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="filters.levels[x + 4]" :label="'Level ' + (x + 4)"></v-checkbox>
                        </v-row>    
                    </v-col>
                </v-row>
            </v-col>
            <v-col sm="3">
                 <h3 class="mb-4">Type Filters:</h3>
                <v-checkbox v-for="type in types" :key="type" dense class="mt-0 mb-0" height="11px" v-model="filters.types[type]" :label="type"></v-checkbox>
            </v-col>
         </v-row>
        <br/><br/>
        
        
        
        
        <div v-for="level in levels" :key="level">      
            <div  v-if="filters.levels[level]">  
            <h2 v-if="filters.levels[level]" :id="level" style="color:cornflowerblue">Level {{level}}:</h2>            
            <table style="width:100%">
                <tr>
                    <th>Name</th>
                    <th>Level</th>
                    <th>Type</th>
                    <th>Range</th>
                    <th>Area</th>
                    <th>Effect</th>
                    <th>Targets</th>
                    <th>Duration</th>
                    <th>Save</th>
                    <th>Description</th>
                </tr>
                <tr v-for="spell in sortedSpells(level)" :key="spell.name"> 
                    <td style="padding-left:4px">{{spell.name}}</td>                    
                    <td style="text-align:center">{{spell.level}}</td>
                    <td style="padding-left:4px"><div v-for="type in spell.type" :key="type">{{type}}</div></td>
                    <td style="padding-left:4px">{{spell.range}}</td>
                    <td style="padding-left:4px">{{spell.area}}</td>
                    <td style="padding-left:4px">{{spell.effect}}</td>
                    <td style="padding-left:4px">{{spell.targets}}</td>
                    <td style="padding-left:4px">{{spell.duration}}</td>
                    <td style="padding-left:4px">{{spell.savingThrow}}</td>
                    <td style="padding-left:4px">{{spell.longDesc}}</td>
                </tr>
            </table>  
            <br/>     
            </div>   
        </div>
        <v-icon style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
    </div>
</template>
<script>
//
import {spells} from "../../../play/data"

export default {
  components: {
  },
  props:{
  },
  mounted(){
    let levels = {0:{cold:[],fire:[],acid:[],electricity:[]},1:{cold:[],fire:[],acid:[],electricity:[]},2:{cold:[],fire:[],acid:[],electricity:[]},3:{cold:[],fire:[],acid:[],electricity:[]},4:{cold:[],fire:[],acid:[],electricity:[]},5:{cold:[],fire:[],acid:[],electricity:[]},6:{cold:[],fire:[],acid:[],electricity:[]},7:{cold:[],fire:[],acid:[],electricity:[]},8:{cold:[],fire:[],acid:[],electricity:[]},9:{cold:[],fire:[],acid:[],electricity:[]}}
    let spellTags = {}
    spells.forEach(spell=>{
        spell.tags.forEach(tag=>{
            if(["acid", "fire", "cold", "electricity"].includes(tag) && !levels[spell.level][tag].includes(spell.name)){
                    levels[spell.level][tag].push(spell.name)
                }
                
            if(spellTags[tag]){
                spellTags[tag] += 1                
            }else{
                spellTags[tag] = 1
            }
        })
    })
    console.log(spellTags)
    console.log(levels)
  },
  data(){
      return{
          types:['damage', 'control', 'buff', 'healing', "utility"],       
          levels:[0,1,2,3,4,5,6,7,8,9],
          filters:{
              levels:{
                  0:true,
                  1:true,
                  2:true,
                  3:true,
                  4:true,
                  5:true,
                  6:true,
                  7:true,
                  8:true,
                  9:true,
              },
              types:{
                  damage:true,
                  control:true,
                  buff:true,
                  healing:true,
                  utility:true,
              }
          }
      }
  },
  methods:{
      sortedSpells(level){
        let filters = {}
        Object.keys(this.filters).forEach(key=>{
            filters[key] = []
            Object.keys(this.filters[key]).forEach(subKey=>{
                if(this.filters[key][subKey]){
                    filters[key].push(subKey)
                }
            })
        })

        let allSpells = [...spells]
        let sortedSpells = allSpells.filter(spell=>spell.level == level && filters.levels.includes(spell.level) && filters.types.some(type=> spell.type.includes(type)))        
        let sorted = sortedSpells.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        sorted = sorted.filter((value, index, self) =>
        index === self.findIndex((t) => (t.name === value.name)))
        return sorted
      },
      scrollTo(id){
        if(id == 'top'){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let section = document.getElementById(id)
            section.scrollIntoView({behavior: "smooth"})
        }
      },    
      filterString(str){
         // let remove = str.replace("Handed"," Handed")
          let newStr = str[0].toUpperCase() + str.substring(1)
          return newStr

      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
.small-label .v-label{
  font-size:12px;
  margin-top:0px;
  margin-bottom:0px;
  padding-top:0px;
}
.small-label .v-messages.theme--light{
  height:0px;
  display:none;
}
</style>